import {ApplicationInsights} from '@microsoft/applicationinsights-web';

export interface AppInsightsTrackEvent {
  name: string;
  properties?: {
    [key: string]: any;
  };
}

class AppInsights {
  private appInsightsInstance: ApplicationInsights;

  private initialized = false;

  init(connectionString: string /* , reactPlugin: ReactPlugin */): ApplicationInsights {
    if (!connectionString) {
      throw new Error('Connection String not provided');
    }
    try {
      if (!this.initialized) {
        this.appInsightsInstance = new ApplicationInsights({
          config: {
            connectionString,
            // extensions: [AppInsights.reactPluginInstance],
          },
        });

        this.appInsightsInstance.loadAppInsights();
        this.appInsightsInstance.trackPageView();
        this.initialized = true;
      }
      return this.appInsightsInstance;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  getAppInsights(): ApplicationInsights {
    if (!this.initialized) {
      throw new Error('AppInsight needs to be initialized');
    }
    return this.appInsightsInstance;
  }

  trackEvent(event: AppInsightsTrackEvent): void {
    if (!this.initialized) {
      throw new Error('AppInsight needs to be initialized');
    }
    this.appInsightsInstance.trackEvent(event);
  }
}

export const appInsights = new AppInsights();
